import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout.vue';
import Login from "@/views/Login";
import HomeWrapper from "@/views/HomeWrapper"

Vue.use(VueRouter)
const routes = [
  {
    path: '/Login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    name: 'HomeView',
    component: HomeWrapper,
    children: [
      {
        path: 'HomeView',
        component: () => import('@/views/HomeView.vue'),
      },
      {
        path: 'Custom',
        component: () => import('@/views/Custom.vue'),
      },
      {
        path: 'Organization',
        component: () => import('@/views/Organization.vue')
      },
      {
        path: 'Visitor',
        component: () => import('@/views/Visitor.vue')
      },
      {
        path: 'Appointment',
        component: () => import('@/views/Appointment.vue')
      },

      {
        path: 'CarType',
        component: () => import('@/views/CarType.vue')
      },
      {
        path: 'Notice',
        component: () => import('@/views/Notice.vue')
      },
      {
        path: 'editor/:id',
        component: () => import('@/views/editor.vue')
      },
      {
        path: 'Config',
        component: () => import('@/views/Config.vue'),
      },
    ],
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router
router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/Login') || isUserLoggedIn()) {
    console.log(localStorage.getItem('userToken'))
    next();
  } else {
    next('/Login');
  }
});

function isUserLoggedIn() {
  // 这里只是一个示例，您可能需要根据实际情况进行调整
  // 比如检查localStorage中的token是否有效
  const token = localStorage.getItem('userToken');
  return token !== null && token !== ''; // 或者检查token是否有效（例如，未过期）
}

